import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";

import PopUpWrapper from "./modal-wrapper";

import DormitoriesApi from "api/dormitories-api";
import EventsApi from "api/events-api";
import UserApi from "api/user-api";

import useModal from "hooks/useModal";
import { useStorageListener } from "hooks/useStorage";

import { EModals } from "types/enums";

const StarredModal = () => {
    const { t } = useTranslation();

    const { isOpened, close } = useModal(EModals.Starred);

    const starredDormitoriesIds = useStorageListener(`user.starredDormitories`, []);
    const starredEventsIds = useStorageListener(`user.starredEvents`, []);
    const dormitories = useStorageListener(`dormitories`, {});
    const events = useStorageListener(`events`, {});

    useEffect(() => {
        if (isOpened) {
            UserApi.getCurrentUser();
            DormitoriesApi.getAllDormitories();
            EventsApi.getEvents();
        }
    }, [isOpened]);

    const starredDormitories = starredDormitoriesIds.map((id) => dormitories[id]).filter((i) => i);
    const starredEvents = starredEventsIds.map((id) => events[id]).filter((i) => i);

    return (
        <PopUpWrapper name={EModals.Starred} extra="align-items: flex-start;">
            <h2>{t("starredModalDormsTitle")}</h2>
            {starredDormitories.length === 0 && <p>{t("selectEmpty")}</p>}
            {starredDormitories.map((dorm) => (
                <Link key={dorm.id} to={`/dormitory/${dorm.id}`} className="my-2" onClick={close}>
                    {_.get(dorm, "details.main-info.name")}
                </Link>
            ))}
            <h2>{t("starredModalEventsTitle")}</h2>
            {starredDormitories.length === 0 && <p>{t("selectEmpty")}</p>}
            {starredEvents.map((event) => (
                <Link key={event.id} to={`/events/${event.id}`} className="my-2" onClick={close}>
                    {_.get(event, "details.name")}
                </Link>
            ))}
        </PopUpWrapper>
    );
};

export default StarredModal;
